export const environment = {
  production: true,
  environment_name: "production",
  release: "976e4ef28798048214ae810f190af2ec88bd852a",

  webshop_base_url: "https://api.mankido.de/webshops/v1/",
  api_base_url: "https://api.mankido.de/merchantcenter/v1/",

  sentry_dsn: "https://fa0dd696f338407d3bc6dd65d9a56285@sentry.mankido.net/4",
  sentry_project_id: "4",

  // configure which new features should be activated
  features: {
    special_points_events: true
  }
};
